import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 5.5A5.506 5.506 0 0 1 5.5 0 5.506 5.506 0 0 1 11 5.5c0 4.706-5 8.262-5.212 8.412a.52.52 0 0 1-.575 0C5 13.762 0 10.206 0 5.5m7.5 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }